// Placeholder SMS service integration.
// Replace the implementation with your preferred provider (Twilio, Vonage, etc.).

/**
 * Sends an approval request SMS to the owner/cleaner.
 * @param {Object} payload
 * @param {string} payload.name - Client name.
 * @param {string} payload.phone - Client phone.
 * @param {string} payload.vehicleSize - Vehicle size.
 * @param {string} payload.condition - Condition level.
 * @param {string} payload.serviceLabel - Service package label.
 * @param {string} payload.preferredDate - Preferred date in ISO format.
 * @returns {Promise<'sent' | 'skipped' | 'error'>}
 */
export async function sendApprovalRequest({
  name,
  phone,
  vehicleSize,
  condition,
  serviceLabel,
  preferredDate,
}) {
  // In production, call your backend endpoint that triggers the SMS.
  // Example (Twilio via Firebase Function):
  // await fetch('/api/send-approval', { method: 'POST', body: JSON.stringify({...}) })
  if (!import.meta.env.VITE_SMS_WEBHOOK_URL) {
    console.warn('SMS webhook missing. Set VITE_SMS_WEBHOOK_URL to enable SMS approvals.');
    return 'skipped';
  }

  try {
    const response = await fetch(import.meta.env.VITE_SMS_WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name,
        phone,
        vehicleSize,
        condition,
        serviceLabel,
        preferredDate,
      }),
    });

    if (!response.ok) {
      throw new Error(`SMS webhook failed with status ${response.status}`);
    }

    return 'sent';
  } catch (error) {
    console.error('Failed to send approval SMS', error);
    return 'error';
  }
}
